// DPS-4708: some extraction fields must change together (ingredients <-> ingredientsHtml,
// seller <-> sellerType), and an imageUrl fix may need a matching gather.json change. The healing
// agent records on review_context:
//   linked_fields_not_updated: [partner]   (a pair attribute's fix left its partner unchanged; [] = fine)
//   linked_field_review_note: string        (only beside a non-empty linked_fields_not_updated)
//   gather_json_review_note: string         (every imageUrl repair; the agent never edits gather.json)
//   linked_field_suggested_change: string   (the agent's description of the partner / gather.json change)
//   linked_field_updated: partner           (the fix PR also writes the partner)
//   linked_field_unverified_note: string    (that partner change was not verified in the sandbox)
// Older jobs and agent versions have none of these and must render exactly as before.

const text = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);

/**
 * The linked-field notes to show a reviewer, or null when there is nothing to show (every field
 * missing, empty or malformed). Non-string partner names are skipped.
 */
export function linkedFieldNotes(ctx) {
  if (!ctx || typeof ctx !== 'object') return null;
  const raw = ctx.linked_fields_not_updated;
  const notUpdated = Array.isArray(raw) ? raw.map(text).filter(Boolean) : [];
  const notes = {
    notUpdated,
    reviewNote: notUpdated.length > 0 ? text(ctx.linked_field_review_note) : null,
    gatherJsonNote: text(ctx.gather_json_review_note),
    suggestedChange: text(ctx.linked_field_suggested_change),
    updated: text(ctx.linked_field_updated),
    unverifiedNote: text(ctx.linked_field_unverified_note),
  };
  const hasAny = notUpdated.length > 0 || notes.reviewNote || notes.gatherJsonNote
    || notes.suggestedChange || notes.updated || notes.unverifiedNote;
  return hasAny ? notes : null;
}
